module.exports = __webpack_public_path__ + "e925a21dcff88a2855670d8e3bd23cb3.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/galo2.svg
// module id = 622
// module chunks = 0